var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import Select from 'react-select';
import styled from 'styled-components';
import colors from '../utils/colors';
var customStyles = {
    option: function () { return ({
        color: colors.TEXT_DEFAULT,
        padding: 8,
    }); },
    control: function (provided, state) { return (__assign(__assign({}, provided), { minWidth: 120, minHeight: undefined, border: state.isFocused ? 0 : 0, 
        // This line disable the blue border
        boxShadow: state.isFocused ? 0 : 0, '&:hover': {
            border: state.isFocused ? 0 : 2,
            borderColor: colors.TP_TURQUOISE,
        }, '&:focus': {
            border: 2,
            borderColor: colors.TP_TURQUOISE,
        } })); },
    indicatorSeparator: function () { return ({}); },
    indicatorsContainer: function () { return ({
        height: 'auto',
        paddingRight: 16,
        paddingLeft: 16,
    }); },
    dropdownIndicator: function (provided) { return (__assign(__assign({}, provided), { padding: 0 })); },
    placeholder: function (provided) { return (__assign(__assign({}, provided), { color: colors.GRAY, marginLeft: 0, marginRight: 0 })); },
    menu: function (provided) { return (__assign(__assign({}, provided), { borderRadius: 0, marginTop: 2, boxShadow: '0 2px 20px 2px rgba(151,151,151,0.3)', zIndex: 100, '&:hover': {
            cursor: 'pointer',
        } })); },
    singleValue: function (provided) { return (__assign(__assign({}, provided), { marginLeft: 0, marginRight: 0 })); },
    valueContainer: function (provided) { return (__assign(__assign({}, provided), { paddingLeft: 16 })); },
    input: function (provided) { return (__assign(__assign({}, provided), { fontSize: 12, margin: 0 })); },
};
var SelectWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  svg {\n    color: ", ";\n  }\n"], ["\n  svg {\n    color: ", ";\n  }\n"])), function (props) { return props.theme.primaryColor || colors.TURQUOISE; });
var OptionSelect = function (props) {
    var options = props.options, onChange = props.onChange, value = props.value;
    return (React.createElement(SelectWrapper, null,
        React.createElement(Select, { options: options, styles: customStyles, 
            // placeholder={"None"}
            onChange: onChange, value: value })));
};
export default OptionSelect;
var templateObject_1;
//# sourceMappingURL=OptionSelect.js.map